import styled from "styled-components";

export const StyledCollaboratorCards = styled.div<{
  $expanded: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  overflow: hidden;
  transition:
    max-height 0.3s ease-out,
    opacity 0.3s ease-out,
    margin-bottom 0.3s ease-out;
  max-height: ${({ $expanded }) => ($expanded ? "0px" : "300px")};
  opacity: ${({ $expanded }) => ($expanded ? 0 : 1)};
  margin-bottom: ${({ $expanded }) => ($expanded ? "0px" : "24px")};
`;
